import * as React from 'react';
import { Link } from 'react-router-dom';
import './scss/auth_status.scss'
import  request  from '@/server/request';
import config from '@/server/config';
import alert from '@/pages/components/common/alert';
import * as utils from '@/server/utils';

class AuthStatus extends React.Component <{} , any> {
	constructor(props: any) {
		super(props);
		this.state = {
			type: '',
			status: '',
			refuseReason: '',
			homeUrl: ''
		};
	}
	componentDidMount() {
		this.initData();
		const webtype = utils.getQueryString('webtype') || 2;
		if(webtype) {
			this.setState({
				homeUrl: webtype === 2 ? `${config.USERAPI}mobile/uc/build/` : `${config.HZAPI}mobile/build/`
			});
		}
		
	}

	render() {
		return (
			<div>
				{
					this.state.status === 0 ?
						<div className="page-authstatus">
							<img src={require('@/assets/images/icon-success.png')} alt="" />
				<p className="title">{this.state.type == 0 ? '企业认证提交成功！' : '加入企业提交成功！'}</p>
							<p className="page-authstatus-text">请耐心等待审核结果，如果有需要欢迎随时致电平台客服电话4009-300-360</p>
						</div> : ''
				}

				{
					this.state.status === 2 ?
						<div className="page-authstatus">
							<img src={require('@/assets/images/icon-tips-fail.png')} alt="" />
				<p className="title">{this.state.type == 0 ? '企业认证' : '加入企业'}审核不通过！</p>
							<p className="page-authstatus-text">{ this.state.refuseReason }</p>
						</div> : ''
				}

				<div className="auth-btns clearfix">
					<Link to={{pathname: '/authentication/applylist', search: 'type=' + this.state.type}}>查看申请记录</Link>
					{ this.state.status === 2 ?
					<button onClick={() => (this.props as any).history.push('/auth/component')}>重新申请</button>
					: null }
				</div>
				<div className="auth-success-block">
					<ul>
						<li>
							<img src={require('@/assets/images/buyer-bg.jpg')} />
							<p>
								<a href={config.WAPAPI + 'buy/supplyBuyOnline.htm'}>发布求购</a>
								<a href={config.WAPAPI + 'supply/list.htm?pageCount=10&spSource=2'}>现货商城</a>
							</p>
						</li>
						<li>
							<img src={require('@/assets/images/seller-bg.jpg')} />
							<p>
								<a href={config.WAPAPI + 'buy/list.html'}>求购报价</a>
								<a href={config.USERAPI + 'mobile/uc/build/releaseSupple'}>发布资源</a>
							</p>
						</li>
					</ul>
				</div>
				<p className="auth-go-home"><a href={this.state.homeUrl}>返回首页</a></p>
			</div>
			
		)
	}

    // 返回初始化数据
	private async initData() {
		const r = await request({
			method: "get",
			url: `${config.CE}member/company/info`,
		});
		if (r.code !== 1) {
			alert.open({
				promptText: r.msg,
			})
		} else {
			const {companyInfo} = r.obj;
			const applyRecode = companyInfo.applyRecode;
			
			if(!companyInfo) {
				return ;
			}

			if(!applyRecode) {
				return ;
			}

			this.setState({
				type: applyRecode.type,
				status: applyRecode.status,
				refuseReason: applyRecode.refuseReason,
			})
		}
	}
}

export default AuthStatus